import React from "react";

const PreviewHeader = ({
  header,
  body,
  primaryColor,
  language,
  handleLanguageChange,
  theme,
}) => {
  const { primaryColor: themPrimary, secondaryColor: themSecondary } =
    theme?.fontStyle || {};
  return (
    <div className="preview_header align-items-center row">
      <div className="col-6">
        {header?.logo?.enabled && (
          <img
            src={header.logo.url}
            alt="header-logo"
            height={41}
            width="auto"
            className="header_logo"
          />
        )}
      </div>
      <div className="col-6">
        <div
          className="language_btn"
          style={{
            border: `1px solid ${primaryColor}`,
          }}
          onClick={() => handleLanguageChange(language === "ar" ? "en" : "ar")}
        >
          <button
            type="button"
            className={`${language === "ar" ? "active" : ""}`}
            style={{
              color: language === "ar" ? themSecondary : themPrimary,
              backgroundColor: language === "ar" ? primaryColor : "unset",
            }}
          >
            AR
          </button>
          <button
            type="button"
            className={`${language === "en" ? "active" : ""}`}
            style={{
              color: language === "en" ? themSecondary : themPrimary,
              backgroundColor: language === "en" ? primaryColor : "unset",
            }}
          >
            EN
          </button>
        </div>
      </div>
    </div>
  );
};

export default PreviewHeader;
